import {
  Backdrop,
  IconButton,
  ListItem,
  LoginButton,
  MenuIcon,
  Paper,
  UserAvatar,
  Button,
  LogoutIcon,
  Box,
  HamburgerMenu,
} from '@zageno/ui';
import { useState, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { navigateToUrl } from 'single-spa';
import { selectPages } from '../../features/header/pagesSlice';
import { useAppSelector, useCategoriesAdapter } from '../../hooks';
import { selectUsername } from '../../features/userSlice';

interface MobileNavigationProps {
  isAuthenticated?: boolean;
}

export default function MobileNavigation({ isAuthenticated }: MobileNavigationProps) {
  const userName = useAppSelector(selectUsername);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
  const pages = useAppSelector(selectPages);
  const categories = useCategoriesAdapter();
  const { t } = useTranslation();

  const closeMenu = (event: MouseEvent<HTMLElement>): void => {
    if (event.target === event.currentTarget) {
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <IconButton
        data-testid="open-modal-button"
        onClick={() => setIsMobileMenuOpen(true)}
        size="large"
        edge="start"
        color="inherit"
        aria-label="menu"
        sx={{ ml: 1, display: { xs: 'inline-flex', md: 'none' } }}
      >
        <MenuIcon />
      </IconButton>
      <Backdrop
        data-testid="backdrop"
        open={isMobileMenuOpen}
        onClick={closeMenu}
        sx={{ alignItems: 'baseline', justifyContent: 'left', zIndex: 1302 }}
      >
        <Paper elevation={0} variant="outlined" sx={{ borderRadius: 0, p: 1 }}>
          <Box>
            {isAuthenticated && (
              <Box display="flex" alignItems="baseline">
                {userName && <UserAvatar userName={userName} sx={{ m: 0 }} />}
                <Box
                  sx={{
                    fontWeight: 'bold',
                    color: 'blue.main',
                    ml: 1,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {t('Hi')}, {userName}
                </Box>
              </Box>
            )}
            {!isAuthenticated && <LoginButton link="/accounts/login" />}
            <HamburgerMenu pages={pages} categories={categories} onClick={() => setIsMobileMenuOpen(false)} />
            {isAuthenticated && (
              <ListItem sx={{ p: 0 }}>
                <Button
                  sx={{ fontWeight: '600' }}
                  variant="transparent"
                  size="small"
                  startIcon={<LogoutIcon />}
                  onClick={() => navigateToUrl('/accounts/logout')}
                >
                  {t('LOG OUT')}
                </Button>
              </ListItem>
            )}
          </Box>
        </Paper>
      </Backdrop>
    </>
  );
}

MobileNavigation.defaultProps = { isAuthenticated: false } as MobileNavigationProps;
